<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="container">
            <nav-bar-box :extr="navData"></nav-bar-box>
            <section>
                <div class="accountsReceive">
                    <div class="main">
                        <div class="search-conditions-con">
                            <div class="search-conditions">
                                <span class="time-con" @click="handleShowDatePop('start_date')">
                                    <i class="iconfont sm-rili"></i>
                                    <span>{{ start_date }}</span>
                                </span>
                                <span>—</span>
                                <span class="time-con" @click="handleShowDatePop('end_date')">
                                    <i class="iconfont sm-rili"></i>
                                    <span>{{ end_date }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="top">
                            <div class="total">
                                <p class="describe iconfont sm-bag">
                                    可用资金：
                                </p>
                                <p class="num">
                                    {{ detailVal.available_fund_total || 0 }}
                                </p>
                                <p class="unit">
                                    单位：万元
                                </p>
                            </div>
                            <div class="header">
                                <div class="item">
                                    <p class="describe2">
                                        累计收入
                                    </p>
                                    <p class="num2">
                                        {{ detailVal.available_income_total || 0 }}
                                    </p>
                                </div>
                                <div class="item">
                                    <p class="describe2">
                                        累计支出
                                    </p>
                                    <p class="num2">
                                        {{ detailVal.available_expenditure_total || 0 }}
                                    </p>
                                </div>
                                <div class="item">
                                    <p class="describe2">
                                        净收入
                                    </p>
                                    <p class="num2">
                                        {{ yodayBalance(detailVal) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="top top1">
                            <div class="total">
                                <p class="describe iconfont sm-bag">
                                    冻结资金：
                                </p>
                                <p class="num">
                                    {{ detailVal.freeze_fund_total || 0 }}
                                </p>
                                <p class="unit">
                                    单位：万元
                                </p>
                            </div>
                            <div class="header">
                                <div class="item">
                                    <p class="describe2">
                                        累计收入
                                    </p>
                                    <p class="num2">
                                        {{ detailVal.freeze_income_total || 0 }}
                                    </p>
                                </div>
                                <div class="item">
                                    <p class="describe2">
                                        累计支出
                                    </p>
                                    <p class="num2">
                                        {{ detailVal.freeze_expenditure_total || 0 }}
                                    </p>
                                </div>
                                <div class="item">
                                    <p class="describe2">
                                        净收入
                                    </p>
                                    <p class="num2">
                                        {{ (detailVal.freeze_income_total || 0) - (detailVal.freeze_expenditure_total || 0) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="table_box">
                            <div class="table_title">
                                单位：万元
                            </div>
                            <div class="tableBox">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>类别</th>
                                            <th>累计收入</th>
                                            <th>累计支出</th>
                                            <th>账户余额</th>
                                            <th>冻结资金</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>总量</th>
                                            <td>{{ tableData.income_total || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.expenditure_total || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.balance_total || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.freeze_fund_total || '0' | displayDecimalControl }}</td>
                                        </tr>
                                        <tr>
                                            <th>银行存款</th>
                                            <td>{{ tableData.bank_income || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.bank_expenditure || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.bank_balance || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.bank_freeze_fund || '0' | displayDecimalControl }}</td>
                                        </tr>
                                        <tr>
                                            <th>银行承兑</th>
                                            <td>{{ tableData.bank_draft_income || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.bank_draft_expenditure || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.bank_draft_balance || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.bank_draft_freeze_fund || '0' | displayDecimalControl }}</td>
                                        </tr>
                                        <tr>
                                            <th>商业承兑</th>
                                            <td>{{ tableData.commercial_draft_income || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.commercial_draft_expenditure || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.commercial_draft_balance || '0' | displayDecimalControl }}</td>
                                            <td>{{ tableData.commercial_draft_freeze_fund || '0' | displayDecimalControl }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="bottom_box" v-for="(item, i) in detailData" :key="i">
                            <div class="bottom">
                                <div class="head">
                                    <div class="title">
                                        {{ item.bank_name || '' }}
                                    </div>
                                    <div class="card_number">
                                        <div class="number">
                                            {{ cardNumber(item.bank_account || '') }}
                                        </div>
                                        <div class="status">
                                            <div>
                                                账户状态:{{ item.account_status === 1 ? '正常' : '冻结' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="split_box">
                                    <div class="left"></div>
                                    <div class="center"></div>
                                    <div class="right"></div>
                                </div>
                                <div class="deposit_in_bank">
                                    <div class="btn">
                                        银行存款
                                    </div>
                                    <div class="top_yh">
                                        <div class="header">
                                            <div class="item">
                                                <p class="num">
                                                    {{ item.bank_income || 0 }}
                                                </p>
                                                <p class="describe">
                                                    累计收入(万元)
                                                </p>
                                            </div>
                                            <div class="item">
                                                <p class="num">
                                                    {{ item.bank_expenditure || 0 }}
                                                </p>
                                                <p class="describe">
                                                    累计支出(万元)
                                                </p>
                                            </div>
                                            <div class="item">
                                                <p class="num">
                                                    {{ item.bank_balance || 0 }}
                                                </p>
                                                <p class="describe">
                                                    账户余额(万元)
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="border_dashed"></div>
                                <div class="deposit_in_bank">
                                    <div class="btn">
                                        商业汇票
                                    </div>
                                    <div class="top_hp">
                                        <div class="header">
                                            <div class="item">
                                                <div>
                                                    <p class="num">
                                                        {{ item.bank_draft_income || 0 }}
                                                    </p>
                                                    <p class="describe">
                                                        累计收入(万元)
                                                        <span class="tag_type type_yc">银</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="item item2">
                                                <div>
                                                    <p class="num">
                                                        {{ item.commercial_draft_income || 0 }}
                                                    </p>
                                                    <p class="describe">
                                                        累计收入(万元)
                                                        <span class="tag_type type_sc">商</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <div>
                                                    <p class="num">
                                                        {{ item.bank_draft_expenditure || 0 }}
                                                    </p>
                                                    <p class="describe">
                                                        累计支出(万元)
                                                        <span class="tag_type type_yc">银</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="item item2">
                                                <div>
                                                    <p class="num">
                                                        {{ item.commercial_draft_expenditure || 0 }}
                                                    </p>
                                                    <p class="describe">
                                                        累计支出(万元)
                                                        <span class="tag_type type_sc">商</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="item">
                                                <div>
                                                    <p class="num">
                                                        {{ item.bank_draft_balance || 0 }}
                                                    </p>
                                                    <p class="describe">
                                                        账户余额(万元)
                                                        <span class="tag_type type_yc">银</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="item item2">
                                                <div>
                                                    <p class="num">
                                                        {{ item.commercial_draft_balance || 0 }}
                                                    </p>
                                                    <p class="describe">
                                                        账户余额(万元)
                                                        <span class="tag_type type_sc">商</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <van-popup v-model="showDatePop" position="bottom" :style="{ height: '50%' }">
                        <van-datetime-picker
                            v-model="date2Model"
                            type="date"
                            title="选择年月"
                            @confirm="confirmDate"
                            @cancel="showDatePop=false"
                        ></van-datetime-picker>
                    </van-popup>
                </div>
            </section>
        </div>
    </v-touch>
</template>

<script>
import util from '@/assets/js/utils';
import NP from 'number-precision';
import { mixin_showDecimals } from '@/assets/mixin/mixin_showDecimals';

export default {
    components: {},
    props: {},
    mixins: [mixin_showDecimals],
    data() {
        return {
            navData: {
                title: '资金余额日报（鸡西）',
                leftText: '',
                rightText: '',
                leftArrow: true,
            },
            // 唤起日期选择的日期key
            dateKey: '',
            tableData: {},
            showDatePop: false,
            info: {
                current_month_balance_total: 0,
                beginning_year_balance_total: 0,
                beginning_year_ratio_total: 0,
                month_rate_recovery_total: 0,
                year_rate_recovery_total: 0,
            }, // 数据信息
            listData: [], // 列表数据
            // 当前日期
            start_date: '',
            end_date: '',
            date2Model: '',

            detailVal: {},
            detailData: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.start_date = this.end_date = util.theOtherDayTimeFormat('yyyy-MM-dd', 1);
            this.getData();
        },
        yodayBalance(data) {
            return NP.minus(data.available_income_total || 0, data.available_expenditure_total || 0 );
        },
        cardNumber(number) {
            const arr = [];
            number.split('').forEach((item, i) => {
                if (i !== 0 && i % 3 === 0) {
                    arr.push(' ');
                }
                arr.push(item);
            });
            return arr.join('');
        },
        // 点击日期，唤起日期选择
        handleShowDatePop(key) {
            this.dateKey = key;
            this.date2Model = new Date(this[key]);
            this.showDatePop = true;
        },
        // 获取数据
        getData() {
            this.$toast.loading({ overlay: true, duration: 0 });
            const path = `/interfaceApi/report/report/fundbalance/day_report/${this.start_date}?end_date=${this.end_date}`;
            return this.$axios.get(path).then(res => {
                if (res) {
                    this.detailVal = res.total || {};
                    this.detailData = res.details || [];
                    this.tableData = res.total_detail || {};
                }
                this.$toast.clear();
            });
        },
        confirmDate(value) {
            this[this.dateKey] = util.timeFormat(value, 'yyyy-MM');
            this.getData();
            this.showDatePop = false;
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
    },
};
</script>
<style lang="stylus" scoped>
.container
    height 100%
    section
        height calc(100% - 60rpx)
        overflow auto
.accountsReceive
    background #fff
    width 100%
    height 100%
    .charts_header
        margin 12rpx 30rpx
        .van-tabs__nav
            margin 0
    .main
        height calc(100% - 65rpx)
        .search-conditions-con
            padding 10rpx
        .top
            margin: 15rpx
            border-radius 4rpx
            background url(../../../images/fundBalanceDaily/bg@2x.png) right bottom no-repeat, repeating-linear-gradient(to left, #F79187, #EA5D5D)
            background-size: auto 90%
            &.top1
                background url(../../../images/fundBalanceDaily/bg@2x.png) right bottom no-repeat,repeating-linear-gradient(to left, #5D6978, #3B4D5B)
                background-size: auto 90%
            .total
                height 42rpx
                line-height 42px
                color #fff
                display flex
                border-bottom 1px solid rgba(255,255,255,0.2)
                padding 0 20rpx
                position: relative;
                .num
                    font-size 22rpx
                .unit
                    position: absolute;
                    right: 8rpx;
                .describe
                    font-size 16rpx
                    &:before
                        margin-right 5rpx
            .header
                display flex
                justify-content: space-between
                flex-wrap: wrap;
                margin-top 2rpx
                padding 0 20rpx
                .item
                    padding 3rpx 0 5rpx 0
                    color #fff
                    .num2
                        font-size 22rpx
                        margin-top 6rpx
                    .describe2
                        font-size 14rpx
                        margin-bottom 3rpx
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        line-height 25rpx
        .table_box
            position relative
            .table_title
                position absolute
                right 16rpx
                color #000
            .tableBox
                padding 14rpx
                padding-top 24rpx
                table
                    width 100%
                    border-collapse: collapse
                    th,td
                        height: 32rpx
                        color #343434
                        font-size 14rpx
                        border 1px solid #E4E4E4
                        width 20%
                        text-align: center
                    thead
                        th
                            background: #FBEEEE
                            border-color #EAD9D9
                    tbody
                        tr
                            td
                                text-align: right
                                padding 0 7px
                            &:nth-child(even)
                                td
                                    background: #F9FAFD
        .bottom_box
            width 100%
            background #F0F0F0
            padding 12rpx
            .bottom
                width 100%
                height 100%
                background #fff
                border-radius 8rpx
                .head
                    width 100%
                    min-height 65rpx
                    padding 0 30rpx
                    background linear-gradient(#F2DFDF, #fff)
                    border-radius 8rpx
                    .title
                        font-size 18rpx
                        padding 10rpx 0
                        font-family: Medium;
                        color: #082559;
                        font-weight: 500;
                    .card_number
                        font-size 13rpx
                        display flex
                        align-items: center
                        .status
                            margin-left 10rpx
                            transform: skewX(-18deg)
                            border 1px solid #CFEEEF
                            background #F2FCFB
                            color #00AD89
                            padding 0 5rpx
                            >div
                                transform: skewX(18deg)
                .split_box
                    height 30rpx
                    display flex
                    .left
                        width 15rpx
                        height 30rpx
                        border-radius: 0 15rpx 15rpx 0;
                        line-height: 30rpx;
                        background #F0F0F0
                    .center
                        flex 1
                        margin-top 14.5rpx
                        background: linear-gradient( to left, transparent 0%, transparent 50%, #D7D7D7 50%, #D7D7D7 100%)
                        background-size: 12px 1px;
                        background-repeat: repeat-x
                    .right
                        width: 15rpx;
                        height: 30rpx;
                        border-radius: 15rpx 0 0 15rpx;
                        line-height: 30rpx;
                        background #F0F0F0
                .border_dashed
                    width 100%
                    height 5rpx
                    margin 10rpx 0
                    background: linear-gradient( to left, transparent 0%, transparent 50%, #D7D7D7 50%, #D7D7D7 100%)
                    background-size: 12px 1px;
                    background-repeat: repeat-x
                .deposit_in_bank
                    margin-top 3rpx
                    padding 2rpx 30rpx
                    .btn
                        width 80rpx
                        text-align center
                        padding 2rpx
                        background repeating-linear-gradient(to right, #F4E5D6, #D6B6A4)
                        color #553317
                    .top_yh
                        .header
                            display flex
                            justify-content: space-between
                            margin-top 10rpx
                            .item
                                .num
                                    font-size 20rpx
                                    font-weight 600
                                    color #000
                                .describe
                                    color #999999
                                    margin-top 4rpx
                                    font-size 12rpx
                    .top_hp
                        .header
                            display flex
                            margin-top 10rpx
                            flex-wrap wrap
                            .item2
                                padding-left 10rpx
                            .item
                                width calc(100%/2)
                                margin-bottom 12rpx
                                display flex
                                .num
                                    font-size 20rpx
                                    font-weight 600
                                    color #000
                                .describe
                                    color #999999
                                    margin-top 4rpx
                                    font-size 12rpx
                                    line-height: 16rpx
                                    .tag_type
                                        width 20rpx
                                        height 16rpx
                                        color #fff
                                        display inline-block
                                        border-radius: 6px 6px 6px 0px;
                                        text-align: center
                                        &.type_yc
                                            background linear-gradient(#48A0D8, #7FD0FE)
                                        &.type_sc
                                            background linear-gradient(#4EA496, #71C6B0)
                                        >div
                                            transform: skewX(18deg)
        .split
            background #F0F0F0
            height 15rpx
        .chart-con
            padding 10rpx
            position relative
            .btn_box
                position absolute
                right 4rpx
                top 4rpx
                .xs_btn
                    margin-left 5rpx
            h4
                margin 10rpx 0
</style>
